module.exports = __webpack_public_path__ + "media/images/favicons/favicon-fd98c249441da4061403f46cc72f9e67.ico";